module.exports = __webpack_public_path__ + "img/calltracking.8f50ab87.png";